import { Tab, Tabs } from '@material-ui/core';
import React, { FC } from 'react';
import { LayoutVariant } from '../Core/CommonTypes';
import { StatusBoardType } from './StatusTypeList.stories';
// const useStyles = makeStyles(theme => ({
//   statusTypes_scroller: {
//     whiteSpace: 'pre-wrap'
//   },
//   statusTypes_container: {
//     flex: '1 1 auto',
//     display: 'inline-block',
//     position: 'relative'
//   }
// }));

interface StatusTypeListProps {
  statusType?: StatusBoardType;
  statusTypes?: StatusBoardType[];
  onStatusTypeChange?: (statusType: StatusBoardType) => void;
  variant?: LayoutVariant;
}

const StatusTypeList: FC<StatusTypeListProps> = ({
  statusType,
  statusTypes,
  onStatusTypeChange,
  variant
}) => {
  //const classes = useStyles();
  const displayStatusTypes = statusTypes || [];

  // const handleChange = (_e: any, newValue: number) => {
  //   if (onStatusTypeChange) {
  //     onStatusTypeChange(displayStatusTypes[newValue]);
  //   }
  // };

  const handleChange = (newValue: number) => {
    if (onStatusTypeChange) {
      onStatusTypeChange(displayStatusTypes[newValue]);
    }
  };

  return (
    <Tabs
      value={statusType ? displayStatusTypes.indexOf(statusType) : 0}
      indicatorColor="primary"
      textColor="primary"
      variant="scrollable"
      scrollButtons="auto"
      // classes={
      //   variant === LayoutVariant.kiosk
      //     ? {
      //         flexContainer: classes.statusTypes_container,
      //         scroller: classes.statusTypes_scroller
      //       }
      //     : {}
      // }
      aria-label="list of status types"
    >
      {displayStatusTypes.map((statusType, index) => (
        <Tab
          label={statusType.name}
          key={`statusType-${index}`}
          onDoubleClick={() => handleChange(index)}
        />
      ))}
    </Tabs>
  );
};

export default StatusTypeList;
